exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ":root {\n  --tws-backdrop-background-color:  hsla(var(--color-gray-75), 30%);\n}\n", ""]);

